import React from 'react';
import { Link } from 'react-router-dom';
import { FaCar, FaHeartbeat, FaTrain, FaPlane, FaBolt, FaIndustry, FaMicrochip, FaHome } from 'react-icons/fa';
import PageHero from '../components/PageHero';

// const industries = [
//   {
//     icon: <FaCar size={26}/>,
//     title: 'Automotive',
//     desc: 'Robust electronics for vehicle systems requiring durability, EMI compliance, and performance under extreme thermal and vibration conditions.',
//     products: ['ECU assemblies', 'Voltage regulators', 'Body control modules', 'Telematics devices'],
//     badge: 'Design + PCBA',
//   },
//   {
//     icon: <FaHeartbeat size={26}/>,
//     title: 'Healthcare / Medical',
//     desc: 'Precision manufacturing for Class II and III medical devices — meeting stringent regulatory compliance and quality standards.',
//     products: ['Diagnostic equipment', 'Patient monitoring', 'Medical PCBAs', 'Proto & NPI builds'],
//     badge: 'ISO 13485 — 2026-27',
//   },
//   {
//     icon: <FaTrain size={26}/>,
//     title: 'Railways',
//     desc: 'Safety-critical electronics for rolling stock, signalling, and axle counting — serving Japanese, European, and domestic customers.',
//     products: ['Axle counting systems', 'Relay drive cards', 'CPU & event loggers', 'Cubicle wiring harness'],
//     badge: '98–99% OTD',
//   },
//   {
//     icon: <FaPlane size={26}/>,
//     title: 'Defence & Aerospace',
//     desc: 'High-reliability electronics for drone systems, defence platforms, and aerospace — full DFX and traceability from design through delivery.',
//     products: ['Drone power cards', 'Power distribution units', 'NPI builds', 'Wiring harnesses'],
//     badge: 'Full DFX Capability',
//   },
//   {
//     icon: <FaBolt size={26}/>,
//     title: 'Electric Vehicles',
//     desc: 'Power management, BMS, and EV control electronics — designed and manufactured for next-generation electric mobility platforms.',
//     products: ['BMS assemblies', 'Charging controllers', 'Motor drive boards', 'Power modules'],
//     badge: 'EV-Ready Facility',
//   },
//   {
//     icon: <FaIndustry size={26}/>,
//     title: 'Industrial Automation',
//     desc: 'Smart meters, SCADA, chemical dosing pumps, relay systems, and industrial control electronics for factory automation worldwide.',
//     products: ['Smart meters (IoT/BT)', 'Chemical dosing PCBs', 'Relay systems', 'Industrial controllers'],
//     badge: '20M+ Units Produced',
//   },
//   {
//     icon: <FaMicrochip size={26}/>,
//     title: 'Industrial IoT',
//     desc: 'Connected sensor platforms, industrial gateways, and edge computing hardware for Industry 4.0 and smart manufacturing applications.',
//     products: ['IoT gateways', 'Connected sensors', 'Edge compute boards', 'Protocol converters'],
//     badge: 'BLE & LoRa Capable',
//   },
//   {
//     icon: <FaHome size={26}/>,
//     title: 'Advanced Consumer Electronics',
//     desc: 'High-mix consumer electronics requiring fast time-to-market, compact PCB design, and rigorous quality control at scale.',
//     products: ['Smart home devices', 'Wearables', 'Connected appliances', 'Audio/video PCBAs'],
//     badge: 'High-Mix NPI',
//   },
// ];
const industries = [
  {
    icon: <FaCar size={26}/>,
    title: 'Automotive',
    desc: 'Robust electronics for vehicle systems requiring durability, EMI compliance, and performance under extreme thermal and vibration conditions.',
    bg: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800&auto=format&fit=crop',
    products: ['ECU assemblies', 'Voltage regulators', 'Body control modules', 'Telematics devices'],
    badge: 'Design + PCBA',
  },
  {
    icon: <FaHeartbeat size={26}/>,
    title: 'Healthcare / Medical',
    desc: 'Precision manufacturing for Class II and III medical devices — meeting stringent regulatory compliance and quality standards.',
    bg: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&auto=format&fit=crop',
    products: ['Diagnostic equipment', 'Patient monitoring', 'Medical PCBAs', 'Proto & NPI builds'],
    badge: 'ISO 13485 — 2026-27',
  },
  {
    icon: <FaTrain size={26}/>,
    title: 'Railways',
    desc: 'Safety-critical electronics for rolling stock, signalling, and axle counting — serving Japanese, European, and domestic customers.',
    bg: 'https://images.unsplash.com/photo-1474487548417-781cb71495f3?w=800&auto=format&fit=crop',
    products: ['Axle counting systems', 'Relay drive cards', 'CPU & event loggers', 'Cubicle wiring harness'],
    badge: '98–99% OTD',
  },
  {
    icon: <FaPlane size={26}/>,
    title: 'Defence & Aerospace',
    desc: 'High-reliability electronics for drone systems, defence platforms, and aerospace — full DFX and traceability from design through delivery.',
    bg: 'https://images.pexels.com/photos/36278969/pexels-photo-36278969.jpeg',
    products: ['Drone power cards', 'Power distribution units', 'NPI builds', 'Wiring harnesses'],
    badge: 'Full DFX Capability',
  },
  {
    icon: <FaBolt size={26}/>,
    title: 'Electric Vehicles',
    desc: 'Power management, BMS, and EV control electronics — designed and manufactured for next-generation electric mobility platforms.',
    bg: 'https://images.pexels.com/photos/9800006/pexels-photo-9800006.jpeg',
    products: ['BMS assemblies', 'Charging controllers', 'Motor drive boards', 'Power modules'],
    badge: 'EV-Ready Facility',
  },
  {
    icon: <FaIndustry size={26}/>,
    title: 'Industrial Automation',
    desc: 'Smart meters, SCADA, chemical dosing pumps, relay systems, and industrial control electronics for factory automation worldwide.',
    bg: 'https://images.pexels.com/photos/18471536/pexels-photo-18471536.jpeg',
    products: ['Smart meters (IoT/BT)', 'Chemical dosing PCBs', 'Relay systems', 'Industrial controllers'],
    badge: '20M+ Units Produced',
  },
  {
    icon: <FaMicrochip size={26}/>,
    title: 'Industrial IoT',
    desc: 'Connected sensor platforms, industrial gateways, and edge computing hardware for Industry 4.0 and smart manufacturing applications.',
    bg: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&auto=format&fit=crop',
    products: ['IoT gateways', 'Connected sensors', 'Edge compute boards', 'Protocol converters'],
    badge: 'BLE & LoRa Capable',
  },
  {
    icon: <FaHome size={26}/>,
    title: 'Advanced Consumer Electronics',
    desc: 'High-mix consumer electronics requiring fast time-to-market, compact PCB design, and rigorous quality control at scale.',
    bg: 'https://images.pexels.com/photos/32026177/pexels-photo-32026177.jpeg',
    products: ['Smart home devices', 'Wearables', 'Connected appliances', 'Audio/video PCBAs'],
    badge: 'High-Mix NPI',
  },
];
export default function Industries() {
  return (
    <div>
      <PageHero
        chip="Focus Segments"
        title="Industries & Market Presence"
        subtitle="Trusted by global OEMs across safety-critical and high-reliability industries — delivering ISO-certified quality at scale."
      />

      {/* <section className="sec">
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <div className="g2 reveal" style={{ gap:20 }}>
            {industries.map(ind => (
              <div key={ind.title} className="card" style={{ display:'flex', gap:20, padding:'26px 26px' }}>
                <div>
                  <div className="ib">{ind.icon}</div>
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:8, marginBottom:8 }}>
                    <h3 className="h3" style={{ marginBottom:0 }}>{ind.title}</h3>
                    <span className="badge">{ind.badge}</span>
                  </div>
                  <p style={{ fontSize:14, color:'#64748b', lineHeight:1.68, marginBottom:14 }}>{ind.desc}</p>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:7 }}>
                    {ind.products.map(p => (
                      <span key={p} className="tag">{p}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

<section className="sec">
  <div className="wrap" style={{ width: '100%', maxWidth: '100%', padding: '0 24px' }}>
    <div className="g2 reveal" style={{ gap: 20 }}>
      {industries.map(ind => (
        <div
          key={ind.title}
          className="card"
          style={{
            display: 'flex',
            gap: 20,
            padding: '26px 26px',
            backgroundImage: `url(${ind.bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            overflow: 'hidden',
            border: 'none',
          }}
        >
          {/* Dark gradient overlay from left — clean & professional */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.55) 60%, rgba(0,0,0,0.35) 100%)',
              zIndex: 0,
            }}
          />

          {/* Icon */}
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div className="ib">{ind.icon}</div>
          </div>

          {/* Content */}
          <div style={{ flex: 1, position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
              <h3 className="h3" style={{ marginBottom: 0, color: '#ffffff', fontWeight: 700 }}>
                {ind.title}
              </h3>
              <span className="badge">{ind.badge}</span>
            </div>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.88)', lineHeight: 1.68, marginBottom: 14, fontWeight: 400 }}>
              {ind.desc}
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7 }}>
              {ind.products.map(p => (
                <span
                  key={p}
                  className="tag"
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.15)',
                    color: '#ffffff',
                    border: '1px solid rgba(255,255,255,0.3)',
                    fontWeight: 500,
                  }}
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
      {/* Cert timeline */}
      <section style={{ background:'#1a1a2e', padding:'52px 0' }}>
        <div className="wrap" style={{ textAlign:'center' }}>
          <p style={{ fontSize:11, fontWeight:700, letterSpacing:'.13em', textTransform:'uppercase', color:'#5cb85c', marginBottom:20 }}>
            Certification Roadmap
          </p>
          <div style={{ display:'flex', flexWrap:'wrap', gap:12, justifyContent:'center' }}>
            {[
              'ISO 9001:2015 — Active',
              'ZED Bronze — Active',
              'ISO 14001 — 2026-27',
              'ISO 45001 — 2026-27',
              'ISO 13485 — 2026-27',
              'AS 9100 — 2026-27',
            ].map(c => (
              <span key={c} style={{ fontSize:13, fontWeight:500, padding:'8px 18px', borderRadius:8,
                background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', color:'#e2e8f0' }}>
                {c}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="sec-sm" style={{ textAlign:'center' }}>
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <h2 className="h2" style={{ marginBottom:10 }}>Serving your industry?</h2>
          <p className="sub" style={{ margin:'0 auto 26px' }}>Contact us to discuss your specific requirements and compliance needs.</p>
          <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
            <Link to="/projects" className="btn btn-outline">See Key Projects</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
